var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.5 30.333a2.5 2.5 0 0 1 2.5 2.5V44.5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 3 44.5V32.833a2.5 2.5 0 0 1 2.5-2.5h11ZM16.5 12.667a2.5 2.5 0 0 1 2.5 2.5v11.666a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5V15.167a2.5 2.5 0 0 1 2.5-2.5h11Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M13.182 13H6.5A2.5 2.5 0 0 0 4 15.5v29A2.5 2.5 0 0 0 6.5 47h7.1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M43.5 29.667a2.5 2.5 0 0 1-2.5-2.5V15.5a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v11.667a2.5 2.5 0 0 1-2.5 2.5h-11ZM43.5 47.333a2.5 2.5 0 0 1-2.5-2.5V33.167a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v11.666a2.5 2.5 0 0 1-2.5 2.5h-11Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M46.818 47H53.5a2.5 2.5 0 0 0 2.5-2.5v-29a2.5 2.5 0 0 0-2.5-2.5h-7.1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M26.5 46a2.5 2.5 0 0 1-2.5-2.5v-27a2.5 2.5 0 0 1 2.5-2.5h7a2.5 2.5 0 0 1 2.5 2.5v27a2.5 2.5 0 0 1-2.5 2.5h-7Z"
})));
SvgRectangle42BError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42BError);
export default ForwardRef;